import { TransportEnum } from '../enums/TransferTransportEnum';
import { TransferVehicleEnum, getSupplierVehicleChoices } from '../enums/TransferVehicleEnum';
import {translateFunction} from "../../core/languages/hooks/useTranslate";
import {
    arrivalFromLabelChoices,
    departureToLabelChoices,
    transportReferenceLabelChoices,
    transportReferenceNumberLabelChoices,
    arrivalDateLabelChoices,
    departureDateLabelChoices,
    arrivalTimeLabelChoices,
    departureTimeLabelChoices
} from "./transferLabels";

export const getTransportLocationLabel = (
    t: translateFunction,
    transport: TransportEnum | string | number | null | undefined,
    locationType: 'arrivalFrom' | 'arrivalTo' | 'departureFrom' | 'departureTo'
): string => {
    const transportNum = typeof transport === 'string' ? parseInt(transport) : transport;

    switch (locationType) {
        case 'arrivalFrom':
            return t(arrivalFromLabelChoices.find(choice => choice.id === transportNum)?.name || t('transfers.fields.arrivalLocationFrom'));
        case 'arrivalTo':
            return t('transfers.fields.arrivalLocationTo') || 'Going to';
        case 'departureFrom':
            return t('transfers.fields.departureLocationFrom') || 'Pick up location';
        case 'departureTo':
            return t(departureToLabelChoices.find(choice => choice.id === transportNum)?.name || t('transfers.fields.departureLocationTo'));
        default:
            return 'Location';
    }
};

export const getTransportReferenceLabel = (
    t: translateFunction,
    transport: TransportEnum | string | number | null | undefined,
    referenceType: 'reference' | 'number'
): string => {
    const transportNum = typeof transport === 'string' ? parseInt(transport) : transport;
    const choices = referenceType === 'reference' ? transportReferenceLabelChoices : transportReferenceNumberLabelChoices;
    
    return t(choices.find(choice => choice.id === transportNum)?.name || t('transfers.fields.transportReference'));
};

export const getTransportDateLabel = (
    t: translateFunction,
    transport: TransportEnum | string | number | null | undefined,
    direction: 'arrival' | 'departure'
): string => {
    const transportNum = typeof transport === 'string' ? parseInt(transport) : transport;
    const choices = direction === 'arrival' ? arrivalDateLabelChoices : departureDateLabelChoices;
    const fallbackKey = direction === 'arrival' ? 'transfers.fields.arrivalTransportDate' : 'transfers.fields.departureTransportDate';
    
    return t(choices.find(choice => choice.id === transportNum)?.name || fallbackKey);
};

export const getTransportTimeLabel = (
    t: translateFunction,
    transport: TransportEnum | string | number | null | undefined,
    direction: 'arrival' | 'departure'
): string => {
    const transportNum = typeof transport === 'string' ? parseInt(transport) : transport;
    const choices = direction === 'arrival' ? arrivalTimeLabelChoices : departureTimeLabelChoices;
    const fallbackKey = direction === 'arrival' ? 'transfers.fields.arrivalTransportTime' : 'transfers.fields.departureTransportTime';
    
    return t(choices.find(choice => choice.id === transportNum)?.name || fallbackKey);
};

export const getVehicleLabel = (
    t: translateFunction,
    vehicle: TransferVehicleEnum | string | number | null | undefined
): string => {
    const vehicleNum = typeof vehicle === 'string' ? parseInt(vehicle) : vehicle;

    if (vehicleNum === null || vehicleNum === undefined){
        return ""
    }

    const choices = getSupplierVehicleChoices(t);
    const vehicleChoice = choices.find(choice => choice.id === vehicleNum);

    return vehicleChoice?.label || 'transfers.fields.vehicle';
};

export const getTransportTypeLabel = (
    t: translateFunction,
    transport: TransportEnum | string | number | null | undefined
): string => {
    const transportNum = typeof transport === 'string' ? parseInt(transport) : transport;

    const transportChoice = Object.values(TransportEnum).find(choice => choice === transportNum);

    return transportChoice ? t(`transfers.transportTypes.${transportChoice}`) : 'transfers.fields.transportType';
}

export const getTransportDetailsIcon = (
    transport: TransportEnum | string | number | null | undefined
): string => {
    const transportNum = typeof transport === 'string' ? parseInt(transport) : transport;

    switch (transportNum) {
        case TransportEnum.AIRPLANE:
            return 'las la-plane';
        case TransportEnum.TRAIN:
            return 'las la-train';
        case TransportEnum.BUS:
            return 'las la-bus';
        case TransportEnum.OTHER:
        default:
            return 'las la-car';
    }
};

export const getTransportDetailsLabel = (
    t: translateFunction,
    transport: TransportEnum | string | number | null | undefined
): string => {
    const transportNum = typeof transport === 'string' ? parseInt(transport) : transport;

    switch (transportNum) {
        case TransportEnum.AIRPLANE:
            return t('transferOk.message.flightDetails');
        case TransportEnum.TRAIN:
            return t('transferOk.message.trainDetails');
        case TransportEnum.BUS:
            return t('transferOk.message.busDetails');
        case TransportEnum.OTHER:
        default:
            return t('transferOk.message.transportDetails');
    }
};
